<template>
  
</template>

<script>
import Vue from 'vue'

export default {
  name: 'Verification',
  data () {
    return {

    }
  },
  beforeMount () {
    Vue.axios({
      method: 'POST',
      url: '/user/verification',
      data: {
        key: this.$route.params.key
      },
      mode: 'no-cors',
      withCredentials: true,
      credentials: 'same-origin'
    }).then(response => {
      if (response.data.status) {
        Vue.swal({
            title: this.$translate.text('verification_confirmed'),
            text: '',
            type: 'success',
            showCancelButton: false,
            confirmButtonText: this.$translate.text('verification_you-can-login'),
            reverseButtons: true
        }).then((result) => {
            this.$store.state.isLogged = false
            this.$router.push({ name: 'Login' })
        })
      } else {
        Vue.swal(
          response.data.message ? this.$translate.text(response.data.message) : this.$translate.text('global_an-unexpected-error-occurred'),
          '',
          'warning')
      }
    }).catch(() => {
      Vue.swal(
        this.form.login.alert.danger = this.$translate.text('global_an-unexpected-error-occurred'),
        '',
        'warning')
    })
  }
}
</script>
